import { ControlResultActivityMapper } from "@/models/control-result-activity.model";
import { ControlResultMapper } from "@/models/control-results.model";
import {
  bulkUpdateControlResultOwner,
  bulkUpdateControlResultPriority,
  bulkUpdateControlResultWorkflowStep,
  getControlResultActivities,
} from "@/spz-api/control-results/control-results";

import type {
  BulkUpdateControlResultOwnerParams,
  BulkUpdateControlResultPriorityParams,
  BulkUpdateControlResultWorkflowStepParams,
  IControlResultRepository,
} from "../interfaces/control-result-repository.interface";

export class ControlResultRepository implements IControlResultRepository {
  async getControlResultActivities(controlId: string, resultId: string) {
    const response = await getControlResultActivities(controlId, resultId);
    return ControlResultActivityMapper.toListItems(response);
  }

  async bulkUpdateOwner({
    controlId,
    newOwnerId,
    resultIds,
    filters,
  }: BulkUpdateControlResultOwnerParams): Promise<void> {
    const requestDto = resultIds
      ? ControlResultMapper.toBulkUpdateOwnerRequestWithResults(
          newOwnerId,
          resultIds,
        )
      : ControlResultMapper.toBulkUpdateOwnerRequestWithFilters(
          newOwnerId,
          filters,
        );
    await bulkUpdateControlResultOwner(controlId, requestDto);
  }

  async bulkUpdateWorkflowStep({
    controlId,
    transitionId,
    formData,
    resultIds,
    filters,
  }: BulkUpdateControlResultWorkflowStepParams): Promise<void> {
    const requestDto =
      resultIds?.length > 0
        ? ControlResultMapper.toBulkUpdateWorkflowStepRequestWithResults(
            transitionId,
            formData,
            resultIds,
          )
        : ControlResultMapper.toBulkUpdateWorkflowStepRequestWithFilters(
            transitionId,
            formData,
            filters,
          );

    await bulkUpdateControlResultWorkflowStep(controlId, requestDto);
  }

  async bulkChangePriority({
    controlId,
    newPriorityId,
    resultIds,
    filters,
  }: BulkUpdateControlResultPriorityParams): Promise<void> {
    await bulkUpdateControlResultPriority(controlId, {
      priorityId: newPriorityId,
      resultIds: resultIds,
      filters: filters,
    });
  }
}
